const toNumber = (value) => {
  const numeric = typeof value === 'string' ? Number(value.replace(/,/g, '')) : Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const calculateEquitySplit = ({
  marketValueGBP,
  mortgageBalanceGBP,
  conveyancingCostsGBP,
  otherCostsGBP,
  splitCount,
}) => {
  const safeMarketValue = Math.max(0, toNumber(marketValueGBP));
  const safeMortgage = Math.max(0, toNumber(mortgageBalanceGBP));
  const safeConveyancing = Math.max(0, toNumber(conveyancingCostsGBP));
  const safeOtherCosts = Math.max(0, toNumber(otherCostsGBP));
  const safeSplitCount = Math.max(2, Math.round(toNumber(splitCount) || 2));

  const totalCosts = safeConveyancing + safeOtherCosts;
  const netEquity = safeMarketValue - safeMortgage - totalCosts;
  const perPerson = netEquity / safeSplitCount;

  return {
    marketValue: safeMarketValue,
    mortgageBalance: safeMortgage,
    conveyancingCosts: safeConveyancing,
    otherCosts: safeOtherCosts,
    totalCosts,
    netEquity,
    splitCount: safeSplitCount,
    perPerson,
  };
};
